import { BUSINESS_INFO } from './business-info';
import { Article, LegalLayout, List } from './LegalLayout';

/**
 * プライバシーポリシー。
 *
 * 事業者名や連絡先は business-info.ts のプレースホルダを参照している。
 * **法務レビューを通していない下書き**なので、公開前に必ず確認を取ること
 * (docs/deployment.md の「法務ページ」を参照)。
 */
export function PrivacyPage() {
  return (
    <LegalLayout
      title="プライバシーポリシー"
      lead={`${BUSINESS_INFO.companyName}（以下「当社」）は、工数・アサイン予実管理サービス「INOU」（以下「本サービス」）の提供にあたり取得する個人情報を、個人情報の保護に関する法律その他の関係法令を遵守し、本ポリシーに従って取り扱います。`}
    >
      <Article heading="1. 取得する情報">
        <p>当社は、本サービスの提供にあたり次の情報を取得します。</p>
        <List
          items={[
            'アカウント情報：氏名、メールアドレス、所属する組織名、本サービス上の権限区分',
            '認証情報：パスワードから生成したハッシュ値、二要素認証の設定、パスキーの公開鍵、個人アクセストークンのハッシュ値。パスワードおよびトークンそのものを当社が保管することはありません。',
            '利用情報：記録された工数、作業メモ、プロジェクトおよびアサインの情報',
            '接続情報：アクセス日時、IP アドレス、ユーザーエージェント、セッションの発行および失効の記録',
            '課金情報：契約しているシートの数と区分。クレジットカード番号は決済代行事業者が取り扱い、当社は保有しません。',
          ]}
        />
      </Article>

      <Article heading="2. 利用目的">
        <List
          items={[
            '本サービスの提供、維持および本人確認のため',
            '不正アクセスおよび不正利用の検知と防止のため',
            '利用料金の請求および決済のため',
            'お問い合わせへの対応および重要なお知らせの通知のため',
            '本サービスの品質改善および新機能の検討のため（この目的では個人を識別できない形に加工した情報を用います）',
            '法令に基づく対応のため',
          ]}
        />
      </Article>

      <Article heading="3. AI クライアントとの連携について">
        <p>
          本サービスは、お客様が利用する AI クライアントからの MCP
          接続を受け付けます。この経路で当社が受け取るのは、お客様の AI
          クライアントが本サービスの機能を呼び出す際に送信した内容
          （記録の対象となる作業内容、時間、プロジェクトの指定など）に限られます。
        </p>
        <p>
          当社がお客様の AI クライアントの会話全体を取得することはありません。
          また、当社は登録データを本サービス外の生成 AI モデルの学習に利用しません。
        </p>
      </Article>

      <Article heading="4. 第三者提供">
        <p>
          当社は、次の場合を除き、あらかじめ本人の同意を得ることなく個人情報を第三者に提供しません。
        </p>
        <List
          items={[
            '法令に基づく場合',
            '人の生命、身体または財産の保護のために必要があり、本人の同意を得ることが困難であるとき',
            '国の機関等が法令の定める事務を遂行することに協力する必要があり、同意を得ることによりその遂行に支障を及ぼすおそれがあるとき',
            '合併その他の事由による事業の承継に伴って提供する場合',
          ]}
        />
      </Article>

      <Article heading="5. 業務委託および外部サービス">
        <p>
          当社は、利用目的の達成に必要な範囲で個人情報の取り扱いを外部に委託することがあります。
          この場合、委託先に対して必要かつ適切な監督を行います。本サービスは、
          インフラストラクチャおよび決済のために外部の事業者を利用しており、
          これらの一部は日本国外に所在します。
        </p>
      </Article>

      <Article heading="6. 安全管理措置">
        <List
          items={[
            'テナントごとにデータを分離し、他のお客様のデータへ到達できない構造としています。',
            'パスワードはハッシュ化して保管し、復元できる形では保持しません。',
            'セッションおよび個人アクセストークンは、平文ではなくハッシュ値を保管します。',
            '二要素認証の秘密情報は暗号化して保管します。',
            '通信はすべて暗号化された経路で行われます。',
          ]}
        />
      </Article>

      <Article heading="7. 保存期間">
        <p>
          当社は、利用目的の達成に必要な期間、個人情報を保存します。利用契約が終了した場合、
          当社が定める期間の経過をもって登録データを削除します。ただし、法令により保存が
          義務付けられている情報については、当該法令に定める期間保存します。
        </p>
      </Article>

      <Article heading="8. 開示・訂正・削除の請求">
        <p>
          ご本人からの求めに応じ、保有個人データの利用目的の通知、開示、内容の訂正、追加、削除、
          利用の停止、消去および第三者提供の停止に対応します。
          {BUSINESS_INFO.privacyContactEmail} までご連絡ください。
          ご本人であることを確認したうえで、法令に従い遅滞なく対応します。
        </p>
      </Article>

      <Article heading="9. Cookie の利用">
        <p>
          本サービスは、ログイン状態を保持するために Cookie を利用します。この Cookie
          は本サービスの動作に必要なものであり、
          広告配信や行動追跡を目的とした第三者への提供は行いません。
        </p>
      </Article>

      <Article heading="10. 本ポリシーの変更">
        <p>
          当社は、本ポリシーを変更することがあります。変更後の内容は本サービス上に掲示した時点から
          適用されます。重要な変更を行う場合には、お客様の登録した連絡先へ通知します。
        </p>
      </Article>

      <Article heading="11. 事業者および問い合わせ窓口">
        <p>
          {BUSINESS_INFO.companyName}
          <br />
          {BUSINESS_INFO.address}
          <br />
          個人情報保護管理者：{BUSINESS_INFO.representative}
          <br />
          窓口：{BUSINESS_INFO.privacyContactEmail}
        </p>
      </Article>
    </LegalLayout>
  );
}
